import { EditNote } from '@mui/icons-material';
import { ToggleButton, Tooltip } from '@mui/material';
import { FC, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
    loading?: boolean;
    disabled?: boolean;
    onSave?: () => unknown;
}

const EditAllPartnersButton: FC<Props> = ({ loading }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const isGlobal = location.search.includes('storeId=global');

    const globalSearch = useMemo(() => {
        if (isGlobal) return location.search.replace(/storeId=global/, 'storeId=overview');
        return location.search.replace(/storeId=[0-9]+|storeId=overview/, 'storeId=global');
    }, [isGlobal, location.search]);

    return (
        <Tooltip title={isGlobal ? 'Edit single partner' : 'Edit all partners'}>
            <ToggleButton
                disabled={loading}
                className="edit-all-partners"
                value="edit-all-partners"
                selected={isGlobal}
                color="primary"
                onClick={() => {
                    navigate({
                        ...location,
                        search: globalSearch,
                    });
                }}
            >
                <EditNote />
            </ToggleButton>
        </Tooltip>
    );
};

export default EditAllPartnersButton;
